import { useTranslation } from "react-i18next";

import { getCalendarIntegrationType, useAppSelector } from "@lib/store";
import { Illustration } from "@atoms";
import { Button } from "@molecules";
import { cn } from "@utils";

import { useConnectCalendar } from "./useConnectCalendar";

/** Asks to connect the calendar, shown instead of the rooms when there's neither a calendar nor occupancy. */
export const HaNCalendarConsent = ({ displayIllustration = true }: { displayIllustration?: boolean }) => {
  const { t } = useTranslation();
  const calendarIntegrationType = useAppSelector(getCalendarIntegrationType);
  const connectCalendar = useConnectCalendar();

  return (
    <div
      data-testid="organisms-hereAndNow-calendarSync-wrapper"
      className="flex flex-col items-center">
      {displayIllustration && (
        <Illustration
          illustration="calendar"
          size="160px"
        />
      )}
      <div
        className={cn("flex w-[295px] flex-col gap-4", {
          "items-center text-center": displayIllustration,
          "items-start text-left": !displayIllustration,
        })}>
        <p className="max-w-[300px] font-semibold">{t("hereAndNow:NotConnectedCalendarTitle")}</p>
        <p className="max-w-[300px]">{t("hereAndNow:NotConnectedCalendarMessage")}</p>
        <Button
          button="tertiary"
          data-testid="organisms-calendar-CalendarEventsList_connect-calendar-button-fs"
          onClick={connectCalendar}>
          {t("meeting:CalendarBannerButton", { calendarIntegrationType })}
        </Button>
      </div>
    </div>
  );
};
